@if (!isPG()) {
	<div
		class="flex flex-col-reverse justify-between gap-4 px-5 py-4 sm:mx-0 sm:p-5 sm:rounded-lg md:flex-row md:items-center bg-uc-green-700 side-style"
	>
		<div class="space-y-2">
			<p class="font-semibold leading-6 text-white text-normal">{{ title() }}</p>
			<p class="text-sm font-normal leading-5 text-uc-green-100">
				{{ description() }}
			</p>
		</div>
		<uc-clearing-toggle
			[isClearing]="isCLE()"
			(checked)="onClearingToggleChange($event)"
		/>
	</div>
}
